import { render, staticRenderFns } from "./PopupTreatmentDetail.vue?vue&type=template&id=56fd5bf2&"
import script from "./PopupTreatmentDetail.vue?vue&type=script&lang=ts&"
export * from "./PopupTreatmentDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PopupTreatmentDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports